/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import InfoFilledIcon10 from "./InfoFilledIcon10";
import InfoFilledIcon16 from "./InfoFilledIcon16";
import InfoFilledIcon20 from "./InfoFilledIcon20";
import InfoFilledIcon24 from "./InfoFilledIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        10: viewBox ? (
            <InfoFilledIcon10 viewBox={viewBox} width={width ? width : 10} height={height ? height : 10} />
        ) : (
            <InfoFilledIcon10 width={width ? width : 10} height={height ? height : 10} />
        ),
        16: viewBox ? (
            <InfoFilledIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <InfoFilledIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <InfoFilledIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <InfoFilledIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <InfoFilledIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <InfoFilledIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface InfoFilledIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 10 | 16 | 20 | 24;

    /**
     * The fill color for the 'i'.
     */
    innerShapeColor?: string;
}

export const InfoFilledIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,
            innerShapeColor,
            ...rest
        }: InfoFilledIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                        "--sds--ursa-icons--inner-shape-color": innerShapeColor,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
InfoFilledIcon.displayName = "InfoFilledIcon";
